import { useState } from "react";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    IconButton,
} from "@mui/material";
import ProductConfiguration from "./ProductConfiguration";


const CustomProduct = ({ close, onAddProduct, selectedProduct }) => {
    const [product, setProduct] = useState({
        ...selectedProduct,
        name: selectedProduct?.name || `custom_product_${Date.now()}`,
    });

    const [errors, setErrors] = useState({});

    const handleChange = (name, updatedFields) => {
        if (typeof updatedFields === "object") {
            setProduct(updatedFields);
        } else {
            setProduct((prev) => ({ ...prev, [name]: updatedFields }));
        }

        setErrors((prev) => ({ ...prev, [name]: "" }));
    };

    const validate = () => {
        const newErrors = {};
        if (!product?.title?.trim()) newErrors.title = "Product title is required";
        if (!product?.description?.trim())
            newErrors.description = "Description is required";
        if (product?.infoBannerEnabled && !product?.infoBannerText?.trim()) {
            newErrors.infoBannerText = "Banner text is required when enabled";
        }
        if (!product?.clickAction)
            newErrors.clickAction = "Please select a click action";

        if (product?.clickAction === "direct_link" && !product?.directLinkUrl?.trim())
            newErrors.directLinkUrl = "Please enter a valid link";

        if (!product?.color?.trim())
            newErrors.color = "Please select a color";

        if (!product?.iconUrl?.trim())
            newErrors.iconUrl = "Select an icon";

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    const handleSubmit = () => {
        if (!validate()) return;
        onAddProduct(product);
        close();
    };

    return (
        <Dialog fullWidth maxWidth="lg" open>
            <DialogTitle id='alert-dialog-title'>Add Custom Product</DialogTitle>
            <DialogContent>
                <ProductConfiguration
                    product={product}
                    onChange={(name, updatedFields) =>
                        handleChange(name, updatedFields)
                    }
                    errors={errors}
                />

            </DialogContent>
            <Divider />
            <DialogActions>
                <Button variant="outlined" onClick={close}>
                    Cancel
                </Button>
                <Button variant="contained" onClick={handleSubmit}>
                    Save
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default CustomProduct;
